import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=2981b02b&scoped=true&"
var script = {}
import style0 from "./Spinner.scss?vue&type=style&index=0&id=2981b02b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2981b02b",
  null
  
)

export default component.exports